import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector9ABlue13CRed = ({ state, workState }) => (
	<g transform="translate(1581.000000, 1116.000000)">
		<g transform="translate(0.000000, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
		>
			<line x1="171" y1="291" x2="149" y2="232" strokeWidth={tracksWidth}/>

		</g>
	</g>
);

export default Connector9ABlue13CRed;
